import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
  LogoOsloOgVikenPrimaerBokmaalNegativPdf,
  LogoOsloOgVikenPrimaerBokmaalNegativPng,
  LogoOsloOgVikenPrimaerBokmaalNegativSvg,
  LogoOsloOgVikenPrimaerBokmaalPositivPdf,
  LogoOsloOgVikenPrimaerBokmaalPositivPng,
  LogoOsloOgVikenPrimaerBokmaalPositivSvg,
  LogoOsloOgVikenPrimaerBokmaalEngelskNegativPdf,
  LogoOsloOgVikenPrimaerBokmaalEngelskNegativPng,
  LogoOsloOgVikenPrimaerBokmaalEngelskNegativSvg,
  LogoOsloOgVikenPrimaerBokmaalEngelskPositivPdf,
  LogoOsloOgVikenPrimaerBokmaalEngelskPositivPng,
  LogoOsloOgVikenPrimaerBokmaalEngelskPositivSvg,
  LogoOsloOgVikenPrimaerNynorskNegativPdf,
  LogoOsloOgVikenPrimaerNynorskNegativPng,
  LogoOsloOgVikenPrimaerNynorskNegativSvg,
  LogoOsloOgVikenPrimaerNynorskPositivPdf,
  LogoOsloOgVikenPrimaerNynorskPositivPng,
  LogoOsloOgVikenPrimaerNynorskPositivSvg,
  LogoOsloOgVikenPrimaerNynorskEngelskNegativPdf,
  LogoOsloOgVikenPrimaerNynorskEngelskNegativPng,
  LogoOsloOgVikenPrimaerNynorskEngelskNegativSvg,
  LogoOsloOgVikenPrimaerNynorskEngelskPositivPdf,
  LogoOsloOgVikenPrimaerNynorskEngelskPositivPng,
  LogoOsloOgVikenPrimaerNynorskEngelskPositivSvg,
  LogoOsloOgVikenSekundaerBokmaalNegativPdf,
  LogoOsloOgVikenSekundaerBokmaalNegativPng,
  LogoOsloOgVikenSekundaerBokmaalNegativSvg,
  LogoOsloOgVikenSekundaerBokmaalPositivPdf,
  LogoOsloOgVikenSekundaerBokmaalPositivPng,
  LogoOsloOgVikenSekundaerBokmaalPositivSvg,
  LogoOsloOgVikenSekundaerBokmaalEngelskNegativPdf,
  LogoOsloOgVikenSekundaerBokmaalEngelskNegativPng,
  LogoOsloOgVikenSekundaerBokmaalEngelskNegativSvg,
  LogoOsloOgVikenSekundaerBokmaalEngelskPositivPdf,
  LogoOsloOgVikenSekundaerBokmaalEngelskPositivPng,
  LogoOsloOgVikenSekundaerBokmaalEngelskPositivSvg,
  LogoOsloOgVikenSekundaerNynorskNegativPdf,
  LogoOsloOgVikenSekundaerNynorskNegativPng,
  LogoOsloOgVikenSekundaerNynorskNegativSvg,
  LogoOsloOgVikenSekundaerNynorskPositivPdf,
  LogoOsloOgVikenSekundaerNynorskPositivPng,
  LogoOsloOgVikenSekundaerNynorskPositivSvg,
  LogoOsloOgVikenSekundaerNynorskEngelskNegativPdf,
  LogoOsloOgVikenSekundaerNynorskEngelskNegativPng,
  LogoOsloOgVikenSekundaerNynorskEngelskNegativSvg,
  LogoOsloOgVikenSekundaerNynorskEngelskPositivPdf,
  LogoOsloOgVikenSekundaerNynorskEngelskPositivPng,
  LogoOsloOgVikenSekundaerNynorskEngelskPositivSvg,
  LogoOsloOgVikenSentrertBokmaalNegativPdf,
  LogoOsloOgVikenSentrertBokmaalNegativPng,
  LogoOsloOgVikenSentrertBokmaalNegativSvg,
  LogoOsloOgVikenSentrertBokmaalPositivPdf,
  LogoOsloOgVikenSentrertBokmaalPositivPng,
  LogoOsloOgVikenSentrertBokmaalPositivSvg,
  LogoOsloOgVikenSentrertBokmaalEngelskNegativPdf,
  LogoOsloOgVikenSentrertBokmaalEngelskNegativPng,
  LogoOsloOgVikenSentrertBokmaalEngelskNegativSvg,
  LogoOsloOgVikenSentrertBokmaalEngelskPositivPdf,
  LogoOsloOgVikenSentrertBokmaalEngelskPositivPng,
  LogoOsloOgVikenSentrertBokmaalEngelskPositivSvg,
  LogoOsloOgVikenSentrertNynorskNegativPdf,
  LogoOsloOgVikenSentrertNynorskNegativPng,
  LogoOsloOgVikenSentrertNynorskNegativSvg,
  LogoOsloOgVikenSentrertNynorskPositivPdf,
  LogoOsloOgVikenSentrertNynorskPositivPng,
  LogoOsloOgVikenSentrertNynorskPositivSvg,
  LogoOsloOgVikenSentrertNynorskEngelskNegativPdf,
  LogoOsloOgVikenSentrertNynorskEngelskNegativPng,
  LogoOsloOgVikenSentrertNynorskEngelskNegativSvg,
  LogoOsloOgVikenSentrertNynorskEngelskPositivPdf,
  LogoOsloOgVikenSentrertNynorskEngelskPositivPng,
  LogoOsloOgVikenSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Oslo-og-Viken/exportOsloOgViken.js";

export default function OsloOgVikenPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Oslo og Viken"
          lead="Alle logoer for Oslo og Viken i ulike variasjoner og filformater"
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <center><b>Gjelder til 30. juni 2024</b></center>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoOsloOgVikenPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, bokmål"
                    text="Bokmål"
                    blackSvg={LogoOsloOgVikenPrimaerBokmaalPositivSvg}
                    blackPng={LogoOsloOgVikenPrimaerBokmaalPositivPng}
                    blackPdf={LogoOsloOgVikenPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoOsloOgVikenPrimaerBokmaalNegativSvg}
                    whitePng={LogoOsloOgVikenPrimaerBokmaalNegativPng}
                    whitePdf={LogoOsloOgVikenPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOsloOgVikenPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoOsloOgVikenPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoOsloOgVikenPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoOsloOgVikenPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoOsloOgVikenPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoOsloOgVikenPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoOsloOgVikenPrimaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOsloOgVikenPrimaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoOsloOgVikenPrimaerNynorskPositivSvg}
                    blackPng={LogoOsloOgVikenPrimaerNynorskPositivPng}
                    blackPdf={LogoOsloOgVikenPrimaerNynorskPositivPdf}
                    whiteSvg={LogoOsloOgVikenPrimaerNynorskNegativSvg}
                    whitePng={LogoOsloOgVikenPrimaerNynorskNegativPng}
                    whitePdf={LogoOsloOgVikenPrimaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOsloOgVikenPrimaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoOsloOgVikenPrimaerNynorskEngelskPositivSvg}
                    blackPng={LogoOsloOgVikenPrimaerNynorskEngelskPositivPng}
                    blackPdf={LogoOsloOgVikenPrimaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoOsloOgVikenPrimaerNynorskEngelskNegativSvg}
                    whitePng={LogoOsloOgVikenPrimaerNynorskEngelskNegativPng}
                    whitePdf={LogoOsloOgVikenPrimaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoOsloOgVikenSekundaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, bokmål"
                    text="Bokmål"
                    blackSvg={LogoOsloOgVikenSekundaerBokmaalPositivSvg}
                    blackPng={LogoOsloOgVikenSekundaerBokmaalPositivPng}
                    blackPdf={LogoOsloOgVikenSekundaerBokmaalPositivPdf}
                    whiteSvg={LogoOsloOgVikenSekundaerBokmaalNegativSvg}
                    whitePng={LogoOsloOgVikenSekundaerBokmaalNegativPng}
                    whitePdf={LogoOsloOgVikenSekundaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOsloOgVikenSekundaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoOsloOgVikenSekundaerBokmaalEngelskPositivSvg}
                    blackPng={LogoOsloOgVikenSekundaerBokmaalEngelskPositivPng}
                    blackPdf={LogoOsloOgVikenSekundaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoOsloOgVikenSekundaerBokmaalEngelskNegativSvg}
                    whitePng={LogoOsloOgVikenSekundaerBokmaalEngelskNegativPng}
                    whitePdf={LogoOsloOgVikenSekundaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOsloOgVikenSekundaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoOsloOgVikenSekundaerNynorskPositivSvg}
                    blackPng={LogoOsloOgVikenSekundaerNynorskPositivPng}
                    blackPdf={LogoOsloOgVikenSekundaerNynorskPositivPdf}
                    whiteSvg={LogoOsloOgVikenSekundaerNynorskNegativSvg}
                    whitePng={LogoOsloOgVikenSekundaerNynorskNegativPng}
                    whitePdf={LogoOsloOgVikenSekundaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOsloOgVikenSekundaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoOsloOgVikenSekundaerNynorskEngelskPositivSvg}
                    blackPng={LogoOsloOgVikenSekundaerNynorskEngelskPositivPng}
                    blackPdf={LogoOsloOgVikenSekundaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoOsloOgVikenSekundaerNynorskEngelskNegativSvg}
                    whitePng={LogoOsloOgVikenSekundaerNynorskEngelskNegativPng}
                    whitePdf={LogoOsloOgVikenSekundaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentert logo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoOsloOgVikenSentrertBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, bokmål"
                    text="Bokmål"
                    blackSvg={LogoOsloOgVikenSentrertBokmaalPositivSvg}
                    blackPng={LogoOsloOgVikenSentrertBokmaalPositivPng}
                    blackPdf={LogoOsloOgVikenSentrertBokmaalPositivPdf}
                    whiteSvg={LogoOsloOgVikenSentrertBokmaalNegativSvg}
                    whitePng={LogoOsloOgVikenSentrertBokmaalNegativPng}
                    whitePdf={LogoOsloOgVikenSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOsloOgVikenSentrertBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoOsloOgVikenSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoOsloOgVikenSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoOsloOgVikenSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoOsloOgVikenSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoOsloOgVikenSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoOsloOgVikenSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOsloOgVikenSentrertNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoOsloOgVikenSentrertNynorskPositivSvg}
                    blackPng={LogoOsloOgVikenSentrertNynorskPositivPng}
                    blackPdf={LogoOsloOgVikenSentrertNynorskPositivPdf}
                    whiteSvg={LogoOsloOgVikenSentrertNynorskNegativSvg}
                    whitePng={LogoOsloOgVikenSentrertNynorskNegativPng}
                    whitePdf={LogoOsloOgVikenSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoOsloOgVikenSentrertNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Oslo og Viken, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoOsloOgVikenSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoOsloOgVikenSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoOsloOgVikenSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoOsloOgVikenSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoOsloOgVikenSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoOsloOgVikenSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
